// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../flags/tbd.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../flags/cis.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../flags/nato.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../flags/ussr.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../flags/esa.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../flags/iss.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-unknown {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fi-cis {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fi-nato {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.fi-su {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.fi-esa {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.fi-iss {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}`, "",{"version":3,"sources":["webpack://./public/css/flag-icons.css"],"names":[],"mappings":"AAAA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAAwC;AAC5C;;AAEA;IACI,yDAAwC;AAC5C;;AAEA;IACI,yDAAuC;AAC3C;;AAEA;IACI,yDAAuC;AAC3C","sourcesContent":[".fi-unknown {\n    background-image: url(../flags/tbd.png);\n}\n\n.fi-cis {\n    background-image: url(../flags/cis.svg);\n}\n\n.fi-nato {\n    background-image: url(../flags/nato.png);\n}\n\n.fi-su {\n    background-image: url(../flags/ussr.png);\n}\n\n.fi-esa {\n    background-image: url(../flags/esa.png);\n}\n\n.fi-iss {\n    background-image: url(../flags/iss.png);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
